import styled from 'styled-components';
import {
    getToken,
    getSpacingToken,
    getTextTokenPreset,
    ANIMATION_CURVE,
    ANIMATION_DURATION,
} from '@optimus-web/common';
import { Stack, StackProps } from '../Stack';

export const ActionToolbarContainer = styled(Stack)<{ $disabled?: boolean } & StackProps>`
    background-color: ${({ $disabled }) =>
        $disabled ? getToken('backgroundStaticFlat') : getToken('backgroundInteractivePrimaryDefault')};
    border-radius: ${getToken('borderRadius100')}px;
    margin: ${getSpacingToken('100')}px ${getSpacingToken('0')};
    padding: ${getSpacingToken('100')}px ${getSpacingToken('200')}px;
    color: ${({ $disabled }) => ($disabled ? getToken('textDisabled') : getToken('textStaticInverse'))};
    ${getTextTokenPreset('bodyMedium')};
    border: ${({ $disabled, theme }) =>
        `${getToken('borderWidth100')({ theme })}px solid ${
            $disabled ? getToken('borderDisabled')({ theme }) : 'transparent'
        }`};
    transition-property: background-color, color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
`;
